import styled from 'styled-components'

export const HeroContainer = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1170px;
  height: fit-content;
  margin-top: 160px;

  gap: 40px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 90%;
  gap: 0.5rem;
  flex-wrap: wrap;

  @media (max-width: 900px) {
    justify-content: center;
    font-size: ${({ theme }) => theme.fontSizes.h4};
  }
`

type TypewriterContainerProps = {
  maxLength: number
}

export const TypewriterContainer = styled.div<TypewriterContainerProps>`
  width: ${({ maxLength }) => maxLength * 3}rem; // prevent line breaking

  @media (max-width: 900px) {
    width: ${({ maxLength }) => maxLength * 2}rem;
  }

  @media (max-width: 700px) {
    width: ${({ maxLength }) => maxLength}rem;
  }
`
